class Helper {
    constructor() {
        this.ajax = '/';
        this.mhn = ['shz'];
        this.noz = ['noz', 'dk-online'];
        this.om = ['om'];
        this.buttonStates = 0;
        this.init();
    };

    init() {
        const last = Array.from(document.querySelectorAll('.form-submit')).pop();
        if(last) {
            last.classList.remove('d-none');
        }
    };
    
    get csrfParam() {
        let element = document.querySelector('meta[name=csrf-param]');
        return (element) ? element.getAttribute('content') : '';
    };
    
    get csrfToken() {
        let element = document.querySelector('meta[name=csrf-token]');
        return (element) ? element.getAttribute('content') : '';
    }
    
    get isMhn() {
        return this.mhn.includes(this.getMandant());
    };
    
    get isNoz() {
        return this.noz.includes(this.getMandant());
    };

    get isOm() {
        return this.om.includes(this.getMandant());
    };

    get env() {
        let element = document.querySelector('meta[name=env]');
        return (element) ? element.getAttribute('content') : '';
    }

    hide(element) {
        this.addClass(element, 'd-none');
    }

    show(element) {
        this.removeClass(element, 'd-none');
    }

    formatIBAN(t) {
        return t.replace(/[^\dA-Za-z]/g, "").toUpperCase().replace(/(.{4})/g, "$1 ").trim()
    };

    isVisible(element) {
        return !!( element.offsetWidth || element.offsetHeight || element.getClientRects().length );
    }
    
    getClosest(elem, selector) {
        if (!Element.prototype.matches) {
            Element.prototype.matches =
            Element.prototype.matchesSelector ||
            Element.prototype.mozMatchesSelector ||
            Element.prototype.msMatchesSelector ||
            Element.prototype.oMatchesSelector ||
            Element.prototype.webkitMatchesSelector ||
            function(s) {
                let matches = (this.document || this.ownerDocument).querySelectorAll(s),
                    i = matches.length;
                while (--i >= 0 && matches.item(i) !== this) {}
                return i > -1;
            };
        }
        // Get the closest matching element
        for ( ; elem && elem !== document; elem = elem.parentNode ) {
            if ( elem.matches( selector ) ) return elem;
        }
        return null;
    };
    
    getMandant() {
        return document.querySelector('meta[name=author]').getAttribute('content');
    };

    getPathName() {
        let path = window.location.pathname;
        path = path.replace("/angebote/", "");
        path = path.replace("/", "");
        return path;
    };

    humanPrice(val) {
        val = val.toString().replace(",",".");
        val = parseFloat(val).toFixed(2);
        return val.replace(".",",");
    };
    
    scrollTo(query) {
        let element = (query instanceof HTMLElement) ? query : document.querySelector(query);
        if(element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }
    };

    toggleButton(state, element = '.submitButton') {
        (state) ? this.buttonStates++ : this.buttonStates--;
        let buttons = document.querySelectorAll(element);
        if(buttons) {
            buttons.forEach(button => {
                if(this.buttonStates > 0) {
                    if(!button.closest('.inactive') && !button.disabled) {
                        button.setAttribute('data-original-text', button.innerHTML);
                        button.innerHTML = '<div><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Bitte warten...</div>';
                        button.disabled = true;
                    }
                } else {
                    button.disabled = false;
                    if(button.getAttribute('data-original-text')) {
                        button.innerHTML = button.getAttribute('data-original-text');
                    }
                }
            });
        }
    };

    delayedRedirect(url, delay) {
        setTimeout(function() {
            window.location = url;
        }, delay);
    };

    updateSelect(select, options, skipPlaceholder) {
        Array.from(select.options).forEach(element => {
            element.remove();
        });
        
        if(!skipPlaceholder) {
            let option = new Option('- Bitte auswählen -', '');
            select.append(option);
        }
        
        Array.from(options).forEach(option => {
            let element = new Option(option.text, option.value);
            select.append(element);
        });
    };
    
    singleSelect(select) {
        let checkLength = 1;
        if (select.options[0].value == "") {
            checkLength = 2
        }

        if(select.options.length == checkLength) {
            select.classList.add('singleoption');
            if (checkLength == 2) {
                select.value = select.options[1].value;
                select.dispatchEvent(new Event('change'));
            }
        } else {
            select.classList.remove('singleoption');
        }
    }

    createSingleSelect(select) {
        Array.from(select.options).forEach(element => {
            if (element.value == "") {
                element.remove();
            }
        });
        this.singleSelect(select);
    }
    
    addClass(name, classname) {
        let elements = (typeof name === 'string') ? document.querySelectorAll(name) : [name];
        if(elements) {
            elements.forEach(element => {
                element.classList.add(classname);
            });
        }
    }
    
    removeClass(name, classname) {
        let elements = (typeof name === 'string') ? document.querySelectorAll(name) : [name];
        if(elements) {
            elements.forEach(element => {
                element.classList.remove(classname);
            });
        }
    }
    
    getUrlParameter(param) {
        let sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === param) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };
    
    sameHeight(selector) {
        let height = 0;
        let elements = document.querySelectorAll(selector);
        if(elements) {
            elements.forEach(element => {
                if(element.offsetHeight > height) {
                    height = element.offsetHeight;
                }
            });
            
            elements.forEach(element => {
                element.style.height = height + 'px';
            });
        }
    }

    createElementFromHTML(htmlString) {
        var div = document.createElement('div');
        div.innerHTML = htmlString.trim();
        return div.firstChild;
    }

    insertAfter(el, referenceNode) {
        referenceNode.parentNode.insertBefore(el, referenceNode.nextSibling);
    }

    clipboard(value) {
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(value);
        }
    }
}

export let helper = new Helper();
